module.exports = __webpack_public_path__ + "static/tt-2b75dba00a0ea11a6b5a952d05b9b942.jpg";